import Validators from '../validators'

export default (store) => store.createEmbededEntityState({
  lastSave: 'youtube_asset_info',
  timeRestriction: 'youtube_asset_info',
  attrs: [
    'asset_id', 'asset_name', 'asset_type', 'asset_created_dt', 'note', 'source'
  ],
  titles: [
    store.__('asset ID'), store.__('asset name'), store.__('asset type'),
    store.__('created date'), store.__('note'), store.__('source')
  ],
  _sortField: 'asset_id',
  validators: {
    asset_id: Validators.isMandatory(store),
    asset_name: Validators.isMandatory(store),
    asset_type: Validators.isMandatory(store),
    asset_created_dt: Validators.isMandatoryDate(store)
  }
})
